class CartNotification extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.notification = document.querySelector('[data-cart-notification]');
    this.validContent = this.querySelector('[data-cart-notification-valid]');
    this.invalidContent = this.querySelector('[data-cart-notification-invalid]');

    this.trigger;

    this.listeners = {
      onClick: event => (event.currentTarget === event.target || event.target.closest('[data-cart-notification-close]')) && this.close(),
      keyup: event => event.code === 'Escape' && this.trigger && this.trigger.focus(),
      renderContents: debounce(this.renderContents.bind(this), 500),
      close: this.close.bind(this),
    };

    this.notification.addEventListener('keyup', this.listeners.keyup);
    this.notification.addEventListener('click', this.listeners.onClick);
    this.addEventListener('cart-notification:render-contents', this.listeners.renderContents);
    this.querySelectorAll('[data-cart-notification-close]').forEach(button => button.addEventListener('click', this.listeners.close));
  }

  disconnectedCallback() {
    this.notification.removeEventListener('keyup', this.listeners.keyup);
    this.notification.removeEventListener('click', this.listeners.onClick);
    this.removeEventListener('cart-notification:render-contents', this.listeners.renderContents);
    this.querySelectorAll('[data-cart-notification-close]').forEach(button => button.removeEventListener('click', this.listeners.close));
  }

  open(hasError = false) {
    if (hasError) {
      this.validContent.classList.add('hidden');
      this.invalidContent.classList.remove('hidden');
    }
    else {
      this.invalidContent.classList.add('hidden');
      this.validContent.classList.remove('hidden');
    }

    this.notification.showModal();
  }

  close() {
    this.notification.close();
    if (this.trigger) this.trigger.focus();
  }

  renderContents(event) {
    let { parsedState, trigger } = event.detail;
    if (!('sections' in parsedState)) return;

    this.trigger = trigger || null;
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach(section => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section],section.selector);
    });

    this.open();
  }

  renderQuantityError(inventoryQuantity, trigger) {
    this.trigger = trigger || null;
    const errorMessageElem = this.notification.querySelector(
      '[data-cart-notification-error-message]',
    );
    const inventoryQty = parseInt(inventoryQuantity) || 0;

    errorMessageElem.innerText = window.cartStrings.quantityError.replace(
      '[quantity]',
      inventoryQty,
    );

    this.open(true);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'theme-cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-icon-bubble',
        section: 'theme-cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

if (!customElements.get('cart-notification')) {
  customElements.define('cart-notification', CartNotification);
}
